<template>
  <div class="Dashboard-Row Dashboard-DataCard Dashboard-Register">
    <div class="Dashboard-SearchBar">
      <search-item label="年份">
        <el-date-picker
          :value="filters.reportYear"
          @input="val => updateFilters({reportYear: val})"
          type="year"
          value-format="yyyy"
          placeholder="请选择"
        >
        </el-date-picker>
      </search-item>
      <search-item label="校区">
        <area-select
          :value="filters.reportAreaId"
          @input="val => updateFilters({reportAreaId: val})"
          :accessType="isAdmin?0:1"
        />
      </search-item>
      <search-item label="">
        <el-button
          :loading="loading.regist"
          @click="searchList"
          type="primary"
        >搜索</el-button>
      </search-item>
    </div>
    <div class="more-info">
      {{ reportYear }}年注册人数为：{{ registeYearTotal }}人；平台注册会员总数: {{ registeTotal }}人；平台活跃会员总数：{{ activeTotal }}人
    </div>
    <div class="Dashboard-CampusData">
      <div
        class="Dashboard-CampusItem"
        v-loading="loading.regist"
      >
        <div class="Dashboard-title">
          {{ reportYear }}年每月注册数据
        </div>
        <RegisterByMonth
          :data="registePerMonth"
          :changeReportMonthHandle="changeReportMonthHandle"
        />
      </div>
    </div>
    <div class="Dashboard-CampusData">
      <div
        class="Dashboard-CampusItem"
        v-loading="loading.regist || loading.registByDay"
      >
        <div class="Dashboard-title">
          {{ reportYear }}年{{ reportMonth }}月注册数据
        </div>
        <RegisterByDay :data="registePerDay" />
      </div>
    </div>
    <div class="Dashboard-CampusData">
      <div
        class="Dashboard-CampusItem"
        v-loading="loading.regist"
      >
        <div class="Dashboard-title">
          {{ reportYear }}年每月活跃数据
        </div>
        <ActiveUserByMonth :data="activeUser" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RegisterByMonth from './components/RegisterByMonth';
import RegisterByDay from './components/RegisterByDay';
import ActiveUserByMonth from './components/ActiveUserByMonth';
import { getFilters } from '@/utils/index';

export default {
  name: 'CustomerRegister',
  components: {
    RegisterByMonth,
    RegisterByDay,
    ActiveUserByMonth,
  },
  props: {
    isAdmin: Boolean,
  },
  data() {
    let today = this.$formatDate(new Date(), 'yyyy-MM-dd');
    return {
      today: today,
    };
  },
  computed: {
    ...mapGetters('Dashboard', [
      'reportYear',
      'reportMonth',
      'registePerDay',
      'registePerMonth',
      'activeUser',
      'loading',
      'reportMounted',
      'filters',
      'registeTotal',
      'activeTotal',
    ]),
    registeYearTotal() {
      return this.registePerMonth.reduce((pre, curItem) => {
        return pre + curItem.count;
      }, 0);
    },
  },
  mounted() {
    if (!this.reportMounted) {
      this.fetchReportList({
        isAdmin: this.isAdmin ? 1 : 0,
      });
    }
  },
  methods: {
    ...mapActions('Dashboard', ['fetchReportList', 'updateFilters']),
    changeReportYearHandle(val) {
      if (val) {
        let areaId = this.campusFilters.areaId;
        this.fetchReportList({
          isAdmin: this.isAdmin ? 1 : 0,
          year: val,
          areaId: areaId ? areaId : null,
        });
      }
    },
    changeReportAreaHandle(val) {
      if (val) {
        let year = this.campusFilters.year;
        this.fetchReportList({
          isAdmin: this.isAdmin ? 1 : 0,
          year: year ? year : null,
          areaId: val,
        });
      }
    },
    changeReportMonthHandle(month) {
      console.log(month);
      this.fetchReportList({
        isAdmin: this.isAdmin ? 1 : 0,
        month: month,
        updateRegisteByDay: true,
      });
    },
    searchList() {
      this.fetchReportList({
        isAdmin: this.isAdmin ? 1 : 0,
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';
.Dashboard {
  .Dashboard-Row.Dashboard-Register {
    height: auto;
    .Dashboard-SearchBar {
      .filter-item-label {
        min-width: auto;
        width: auto;
      }
    }
  }
  .Dashboard-title {
    font-size: 20px;
    color: #333;
    font-weight: 700;
  }
  @media screen and (max-width: $bigScreenWidth) {
    .Dashboard-title {
      font-size: 14px;
    }
  }
  .Dashboard-DataCard {
    background-color: #fff;
    border-radius: 8px;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
  .more-info {
    margin: 15px;
    font-weight: normal;
    color: #f70707;
  }
  .Dashboard-SearchBar {
    display: flex;
    padding: 10px 0 20px;
    .filter-item {
      margin: 0 0 0 34px;
    }
    .filter-item-input {
      width: 200px;
      .el-input {
        width: 100%;
      }
    }
  }
  .Dashboard-CampusData {
    display: flex;
    padding: 0 15px;
    margin-bottom: 16px;
    .Dashboard-title {
      position: relative;
    }
    .Dashboard-title::before {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 0;
      width: 32px;
      height: 4px;
      background-color: #4e82fb;
    }
    .Dashboard-CampusItem {
      flex: 1;
      &:nth-child(2) {
        flex: 1.4;
      }
    }
  }
}
</style>
